import { useState, useMemo } from "react";
import {
  useGetVistorsQuery,
  GetVistorsDocument,
  useUpdateVisitorMutation,
} from "@/graphql/generated/schema";

export const useVisitorData = (filters: any) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);

  const { search, status, category, remembered, sorted,location } = filters;

  const startDate = filters.startDate;
  const endDate = filters.endDate;

  const { data, loading } = useGetVistorsQuery({
    variables: {
      search,
      limit: pageSize,
      offset: (page - 1) * pageSize,
      startDate,
      endDate,
      signedType: status,
      category,
      remembered,
      sorted,
      location
    },
    pollInterval: 5000,
  });

  const [updateVisitor, { loading: updateLoading }] = useUpdateVisitorMutation({
    refetchQueries: [GetVistorsDocument],
  });

  const visitors = data?.getVistors?.visitor ?? [];
  const totalCount = data?.getVistors?.count ?? 0;
  const totalPages = useMemo(
    () => Math.ceil(totalCount / pageSize),
    [totalCount, pageSize],
  );

  return {
    visitors,
    totalCount,
    totalPages,
    loading: loading || updateLoading,
    updateVisitor,
    page,
    pageSize,
    setPage,
    setPageSize,
  };
};
